import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_STORAGE_ACCOUNTS_AZURE, GET_STORAGE_ACCOUNTS_AZURE_SUCCESS, GET_STORAGE_ACCOUNTS_AZURE_ERROR
} from './constant';

const initialState = {
  phase: INIT,
  azureStorageList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
export function AzureStorageStore(state = initialState, action) {
  switch (action.type) {
    case GET_STORAGE_ACCOUNTS_AZURE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_STORAGE_ACCOUNTS_AZURE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureStorageList: action.data,
        error: null,
      };
    case GET_STORAGE_ACCOUNTS_AZURE_ERROR:
      return { ...state, phase: ERROR, error: action.error };
    default:
      return state;
  }
}
